function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg087Anguilla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 0.002,
    style: {
      fill: "#2E52B2"
    },
    width: 511.998,
    height: 511.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M427.755,295.821c4.907-6.752,8.185-14.997,8.185-24.982v-74.203  c-6.202,4.659-13.907,7.421-22.261,7.421c-12.138,0-22.912-5.829-29.681-14.839c-6.77,9.01-17.544,14.839-29.681,14.839  c-8.353,0-16.059-2.761-22.261-7.418v74.201c0,9.985,3.278,18.232,8.185,24.982H427.755z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M412.318,257.073c2.362-5.763,4.2-14.188,4.2-18.382c0-6.737-8.783-12.198-8.783-12.198   s-8.783,5.461-8.783,12.198c0,4.194,1.838,12.619,4.199,18.382l-5.07,11.448c2.98,1.212,6.237,1.885,9.653,1.885   c3.416,0,6.673-0.673,9.653-1.885L412.318,257.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M377.992,220.007c-6.171,0.836-14.385,3.459-18.017,5.556c-5.835,3.369-6.173,13.704-6.173,13.704   s9.121,4.875,14.955,1.507c3.632-2.097,10.008-7.9,13.816-12.828l12.45-1.333c-0.441-3.186-1.488-6.343-3.194-9.302   c-1.71-2.958-3.919-5.444-6.459-7.418L377.992,220.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M363.058,268.269c3.809,4.925,10.187,10.727,13.818,12.824c5.835,3.368,14.955-1.507,14.955-1.507   s-0.339-10.336-6.173-13.705c-3.633-2.097-11.846-4.717-18.019-5.552l-7.378-10.115c-2.539,1.975-4.75,4.461-6.459,7.416   c-1.707,2.96-2.753,6.116-3.194,9.304L363.058,268.269z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M338.406,293.101c13.86,22.236,45.592,29.679,45.592,29.679s31.733-7.443,45.592-29.679  L338.406,293.101L338.406,293.101z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "255.999,0 255.999,48.896 215.852,89.043 255.999,89.043 255.999,166.956 203.463,166.956   255.999,219.491 255.999,255.999 232.28,255.999 166.956,190.664 166.956,255.999 89.043,255.999 89.043,178.275 11.331,255.999   0,255.999 0,207.103 40.147,166.956 0,166.956 0,89.043 52.535,89.043 0,36.508 0,0 23.719,0 89.043,65.335 89.043,0 166.956,0   166.956,77.723 244.668,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152 104,152 104,255.999 152,255.999 152,152 255.999,152 255.999,104 152,104 152,0   104,0 104,104 0,104 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.958 0,230.82 0,255.999 0,255.999 89.041,166.958  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.137,89.041 255.999,25.179 255.999,0 255.999,0 166.958,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg087Anguilla);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };